import { Controller } from "stimulus";
import flatpickr from "flatpickr";

export default class extends Controller {
  static targets = ["input"];

  connect() {
    this.flatpickr = flatpickr(this.inputTarget, {
      enableTime: true,
      dateFormat: "Z",
      altInput: true,
      altFormat: "m/d h:i K",
    });
  }

  clear() {
    this.flatpickr.clear();
  }
}
